export const MAX_PENDING_FINAID_APPLICATIONS = 10;

export const APPROVAL_BUFFER_DAYS = 2;

export const APPROVAL_BUFFER_MILLI_SECS = APPROVAL_BUFFER_DAYS * 86400000;

export const MAX_CART_VALID_MILLI_SECS = 28 * 86400000;
